module.exports = __webpack_public_path__ + "static/media/presentation_1.f8ae6deb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/icons/presentation_1.svg
// module id = 646
// module chunks = 1